import { axiosConfig } from '../api/axios-config.js'

// 第三方服務設定管理
export const thirdPartyService = {
  // 取得清單
  get: (params, token) => axiosConfig.get('/api/third-party-services', { ...token, params }),

  // 取得平台選項（下拉值＋每平台提示與 settings_template）
  getOptions: (token) => axiosConfig.get('/api/third-party-services/options', token),

  // 取得單筆（無 api_key/api_secret 明文）
  show: (id, token) => axiosConfig.get(`/api/third-party-services/${id}`, token),

  // 新增
  create: (data, token) => axiosConfig.post('/api/third-party-services', data, token),

  // 更新（api_key/api_secret 留空＝不修改）
  update: (id, data, token) => axiosConfig.patch(`/api/third-party-services/${id}`, data, token),

  // 切換啟用/停用
  toggle: (id, token) => axiosConfig.patch(`/api/third-party-services/${id}/toggle`, {}, token),

  // 刪除
  delete: (id, token) => axiosConfig.delete(`/api/third-party-services/${id}`, token),
}
